import React, { useState } from "react";
import { X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export function AuthModal() {
  const { authOpen, authMode, setAuthMode, closeAuth, login, register, startGoogle } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState("");

  if (!authOpen) return null;
  const isLogin = authMode === "login";

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy("submit");
    try {
      if (isLogin) await login(email, password);
      else await register(name, email, password);
      closeAuth();
      setName(""); setEmail(""); setPassword("");
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="overlay" onClick={(e) => { if (e.target === e.currentTarget) closeAuth(); }}>
      <div className="panel auth-panel">
        <button className="close" onClick={closeAuth} aria-label="Close"><X size={20} /></button>
        <span className="eyebrow">ELY WELLBEING</span>
        <h2 className="auth-title">{isLogin ? "Welcome back" : "Create your account"}</h2>
        <p className="auth-sub">Continue your journey — save items, track progress and join live sessions.</p>

        <button type="button" className="google-btn" onClick={startGoogle}>
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35 24 35c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 5.1 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 5.1 29.6 3 24 3 16 3 9.1 7.6 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 45c5.2 0 10-2 13.6-5.2l-6.3-5.3C29.2 36 26.7 37 24 37c-5.3 0-9.7-2.6-11.3-6.6l-6.5 5C9.1 40.4 16 45 24 45z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.3C41.1 36.5 45 31 45 24c0-1.2-.1-2.3-.4-3.5z"/>
          </svg>
          Continue with Google
        </button>

        <div className="auth-divider"><span>or {isLogin ? "sign in" : "sign up"} with email</span></div>

        <form onSubmit={submit} className="auth-form">
          {!isLogin && (
            <div className="field">
              <label>Name</label>
              <input value={name} onChange={(e) => setName(e.target.value)} required placeholder="Your name" />
            </div>
          )}
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@example.com" />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} placeholder="••••••" />
          </div>
          {error && <div className="auth-error">{error}</div>}
          <button className="primary block" type="submit" disabled={busy === "submit"}>
            {busy === "submit" ? "Please wait…" : isLogin ? "Sign in" : "Create account"}
          </button>
        </form>

        <p className="auth-switch">
          {isLogin ? "New to ELY?" : "Already have an account?"}{" "}
          <button className="text-button" onClick={() => setAuthMode(isLogin ? "register" : "login")}>
            {isLogin ? "Create an account" : "Sign in"}
          </button>
        </p>
      </div>
    </div>
  );
}
